import React, { memo, useCallback } from 'react'
import Input from '@sl/ui-library/molecules/Input'

const test = /^\+?0[0-9 ]*$/
const checkNumber = val => val.length === 10

const TelInput = ({ state, setState }) => {
  const { clicked, valid, value } = state.userTel
  const handleInput = useCallback(e => {
    const event = e
    const newVal = e.target.value || ''
    switch (event.type) {
      case 'click':
      case 'focus':
        setState(prev => ({
          ...prev,
          userTel: {
            ...prev.userTel,
            clicked: true,
          },
        }))
        break
      case 'blur':
        setState(prev => ({
          ...prev,
          userTel: {
            ...prev.userTel,
            valid: checkNumber(prev.userTel.value),
          },
        }))
        break
      case 'change':
        if (test.test(event.target.value)) {
          setState(prev => ({
            ...prev,
            userTel: {
              ...prev.userTel,
              value: newVal.slice(0, 10),
              valid: checkNumber(newVal.slice(0, 10)),
            },
          }))
        }
        break
      default:
        break
    }
  }, [])
  const content = (
    <>
      <Input
        id="MooveFormLandingTelInput"
        onChange={handleInput}
        onBlur={handleInput}
        onClick={handleInput}
        onFocus={handleInput}
        error={clicked ? !valid : false}
        success={valid}
        value={value}
        label="Téléphone"
        type="tel"
        style={{ width: '100%' }}
      />
    </>
  )

  return content
}

export default memo(TelInput)
